import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {QuotaMatrixInput} from '@/components/partner-quota-matrix'
import {SectionCard} from '@/components/section-card'
import {HelpIcon} from '@/components/help-icon'
import {useUpdatePartnerQuota, type Partner} from '@/hooks/inci/aliados/use-partners'
import {publicarExito} from '@/lib/avisos'
import {translateApiError} from '@/lib/errors'

export function CuposSection({partner}: {partner: Partner}) {
  const {t} = useTranslation()
  const update = useUpdatePartnerQuota()
  const [quotas, setQuotas] = useState<Record<string, number>>(partner.quotas)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setQuotas(partner.quotas)
  }, [partner.quotas])

  function submit() {
    setError(null)
    update.mutate(
      {userId: partner.user_id, quotas},
      {
        onSuccess: () =>
          publicarExito(t('partnerDetail.cupos.guardado'), t('partnerDetail.cupos.guardadoDetalle'), {
            testId: 'partner-detail-quota-success',
          }),
        onError: (err) => setError(translateApiError(err)),
      }
    )
  }

  const dirty = JSON.stringify(quotas) !== JSON.stringify(partner.quotas)

  return (
    <SectionCard
      title={t('partners.quotaMatrix.title')}
      actions={
        <HelpIcon label={t('partners.quotaDialog.tipLabel')} testId="partner-detail-cupos-tip">
          {t('partners.quotaDialog.description')}
        </HelpIcon>
      }
      bodyClassName="space-y-3 px-5 py-4"
      testId="partner-detail-cupos">
      <QuotaMatrixInput value={quotas} onChange={setQuotas} idPrefix="partner-detail-quota" title={null} />
      {error && <p className="text-sm text-destructive">{error}</p>}
      <div className="flex items-center gap-2">
        <Button
          type="button"
          size="sm"
          disabled={!dirty || update.isPending}
          data-testid="partner-detail-quota-submit"
          onClick={submit}>
          {update.isPending ? t('common.saving') : t('partners.quotaDialog.save')}
        </Button>
      </div>
    </SectionCard>
  )
}
